import { render, staticRenderFns } from "./CargoItem.vue?vue&type=template&id=669ae1a2&scoped=true&"
import script from "./CargoItem.vue?vue&type=script&lang=js&"
export * from "./CargoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ae1a2",
  null
  
)

export default component.exports